import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Doughnut from "react-chartjs-2";
// @ts-expect-error - TS2305 - Module '"react-router"' has no exported member 'ContextRouter'.
import { withRouter } from "react-router";
import Widget from "../../UI/Widget/Widget";
import WidgetHeader from "../../UI/Widget/WidgetHeader";
import WidgetRefreshButton from "./WidgetRefreshButton";
import SuccessScoringGroupService from "../../../Domain/SuccessScoringGroup/SuccessScoringGroup.service";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import ServiceResult, { Loaders } from "../../UI/ServiceResult/ServiceResult";
import { linkToStudentWithParam } from "../../Pages/Advisor/AdvisorRoutes";
import useConfiguration from "../../Hooks/useConfiguration";
const HIGH_RISK_COLOR = "#dc3545";
const MEDIUM_RISK_COLOR = "#ffc107";
const LOW_RISK_COLOR = "#28a745";
const Chart = withRouter((props) => {
    // @ts-expect-error - TS7034 - Variable 'labels' implicitly has type 'any[]' in some locations where its type cannot be determined.
    const labels = [];
    // @ts-expect-error - TS7034 - Variable 'studentCounts' implicitly has type 'any[]' in some locations where its type cannot be determined.
    const studentCounts = [];
    // @ts-expect-error - TS7034 - Variable 'backgroundColors' implicitly has type 'any[]' in some locations where its type cannot be determined.
    const backgroundColors = [];
    let total = 0;
    // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    props.summary.forEach((item) => {
        total += item.studentCount;
    });
    // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    props.summary.forEach((item) => {
        labels.push(item.name + " (" + Math.round((item.studentCount / total) * 100) + "%)");
        studentCounts.push(item.studentCount);
        if (item.id === 1) {
            backgroundColors.push(HIGH_RISK_COLOR);
        }
        else if (item.id === 2) {
            backgroundColors.push(MEDIUM_RISK_COLOR);
        }
        else if (item.id === 3) {
            backgroundColors.push(LOW_RISK_COLOR);
        }
    });
    let label = "";
    let redirectUrl = "";
    if (props.courseRisk === true) {
        label = "Students By Course Completion Risk";
        redirectUrl = linkToStudentWithParam({
            paramString: "?courseSuccessScoringGroups=",
        });
    }
    else {
        label = "Students By Persistence Risk";
        redirectUrl = linkToStudentWithParam({
            paramString: "?termSuccessScoringGroups=",
        });
    }
    const data = {
        // @ts-expect-error - TS7005 - Variable 'labels' implicitly has an 'any[]' type.
        labels,
        datasets: [
            {
                label,
                // @ts-expect-error - TS7005 - Variable 'studentCounts' implicitly has an 'any[]' type.
                data: studentCounts,
                // @ts-expect-error - TS7005 - Variable 'backgroundColors' implicitly has an 'any[]' type.
                backgroundColor: backgroundColors,
            },
        ],
    };
    const options = {
        legend: {
            position: "bottom",
            labels: {
                boxWidth: 12,
            },
        },
        responsive: true,
        cutoutPercentage: 50,
        animation: {
            animateRotate: true,
        },
        hover: {
            // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
            onHover(e) {
                // @ts-expect-error - TS2339 - Property 'getElementAtEvent' does not exist on type '{ readonly onHover: (e: any) => void; }'.
                const point = this.getElementAtEvent(e);
                if (point.length)
                    e.target.style.cursor = "pointer";
                else
                    e.target.style.cursor = "default";
            },
        },
    };
    return (_jsx("div", { className: "chart-wrap", children: _jsx(Doughnut, { data: data, options: options, onElementsClick: (elems) => {
                let groupClicked;
                switch (elems[0]._options.backgroundColor) {
                    case HIGH_RISK_COLOR:
                        groupClicked = SuccessScoringGroupService.HighId;
                        break;
                    case MEDIUM_RISK_COLOR:
                        groupClicked = SuccessScoringGroupService.MediumId;
                        break;
                    case LOW_RISK_COLOR:
                        groupClicked = SuccessScoringGroupService.LowId;
                        break;
                    default:
                        groupClicked = "";
                }
                props.history.push(redirectUrl + groupClicked);
            } }) }));
});
const CaseloadRiskChartWidget = (props) => {
    const personTypeImportEnabledConfiguration = useConfiguration("personTypeImportEnabled");
    return (_jsxs(Widget, { children: [_jsx(WidgetHeader, { title: "Student Caseload " +
                    (props.courseRisk ? "Course Completion " : "Term Persistence ") +
                    "Risk Summary", subtitle: {
                    content: personTypeImportEnabledConfiguration
                        ? ""
                        : "This widget only shows " +
                            (props.courseRisk ? "course completion " : "term persistence ") +
                            " for users with the student person type",
                }, children: _jsx("div", { className: "text-nowrap ml-2", children: _jsx(WidgetRefreshButton, { isLoading: props.data.isLoading, onRefresh: props.refresh }) }) }), _jsx(ServiceResult, { state: props.data, errorClassName: "m-3", errorMessage: "Error loading chart data", loader: Loaders.hideLoader(), children: (data) => data.length > 0 ? (_jsx("div", { className: "custom-scrollbar", style: { overflow: "auto" }, children: _jsx(Chart, { summary: data, courseRisk: props.courseRisk }) })) : (_jsx("div", { className: "card-body", children: _jsx(AlertInfo, { message: "There is no data to display at this time" }) })) })] }));
};
export default CaseloadRiskChartWidget;
